export default "__VITE_ASSET__DK7fUday__"